module.exports = __webpack_public_path__ + "static/mid1-91d4be4f5558939f42f86333c92e7067.png";